import React from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/MenuOutlined";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/TrendingUpOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";

import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";

const menuItems = ["Features", "Pricing", "Contact"];

const LandingPageMenu = ({ navigate }) => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position="sticky">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} />
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        sx={{
                            marginRight: 16,
                            display: { xs: "none", md: "flex" },
                            fontFamily: "monospace",
                            fontWeight: 700,
                            letterSpacing: ".3rem",
                            color: "inherit",
                            textDecoration: "none",
                        }}>
                        INODIO
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit">
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: "block", md: "none" },
                            }}>
                            {menuItems.map((page) => (
                                <MenuItem key={page} onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center">{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} />
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        sx={{
                            mr: 2,
                            display: { xs: "flex", md: "none" },
                            flexGrow: 1,
                            fontFamily: "monospace",
                            fontWeight: 700,
                            letterSpacing: ".3rem",
                            color: "inherit",
                            textDecoration: "none",
                        }}>
                        INODIO
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                        {menuItems.map((page) => (
                            <Button
                                key={page}
                                onClick={handleCloseNavMenu}
                                sx={{ my: 2, display: "block" }}>
                                {page}
                            </Button>
                        ))}
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <Button
                            onClick={() => navigate("/login")}
                            startIcon={<LoginOutlinedIcon />}
                            variant="contained">
                            Přihlásit
                        </Button>
                        <Menu
                            sx={{ marginTop: "45px" }}
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}>
                            {menuItems.map((setting) => (
                                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

const FeatureIcon = ({ icon, title }) => {
    return (
        <Box sx={(theme) => ({ display: "flex", gap: theme.spacing(4) })}>
            <Box sx={{ flex: "0 0 auto", fontSize: 100 }}>{icon}</Box>
            <Box sx={{ flex: "1 1 auto" }}>
                <Typography variant="h5" component="div">
                    Nadpis
                </Typography>
                <Typography variant="body1" component="div">
                    více informací
                </Typography>
            </Box>
        </Box>
    );
};

const LandingPage = ({ since = 2013 }) => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1, overflowY: "auto" }}>
            <Box sx={{ flex: "0 0 auto" }}>
                <LandingPageMenu navigate={navigate} />
            </Box>
            {/* main hero section */}
            <Box sx={{ flex: "1 1 auto" }}>
                <Container maxWidth="xl">
                    <Box
                        sx={(theme) => ({
                            py: 8,
                            textAlign: "center",
                            minHeight: 500,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                        })}>
                        <Typography variant="h2" gutterBottom>
                            Mějte přehled o svém podnikání
                        </Typography>
                        <Button
                            onClick={() => navigate("/signup")}
                            variant="contained"
                            size="large">
                            Zaregistrovat
                        </Button>
                    </Box>
                </Container>
                {/* features */}
                <Box
                    sx={{
                        //backgroundColor: theme.palette.primaryFixedDim.main,
                        background: `linear-gradient(123deg, ${theme.palette.primaryContainer.main} -10%, ${theme.palette.primaryFixedDim.main} 20%)`,
                        color: theme.palette.onPrimaryFixedVariant.main,
                        py: 8,
                        minHeight: 300,
                    }}>
                    <Container maxWidth="xl">
                        <ul>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </Container>
                </Box>
                {/* flexibility */}
                <Box
                    sx={{
                        py: 8,
                        minHeight: 300,
                    }}>
                    <Container maxWidth="xl"></Container>
                </Box>
                {/* testimonials */}
                <Box
                    sx={{
                        py: 8,
                        minHeight: 300,
                    }}>
                    <Container maxWidth="xl"></Container>
                </Box>
                {/* pricing */}
                <Box
                    sx={{
                        py: 8,
                        minHeight: 300,
                    }}>
                    <Container maxWidth="xl"></Container>
                </Box>
            </Box>
            {/* footer - TODO implement properly */}
            <Box sx={{ flex: "0 0 auto", py: 2 }}>
                <Container maxWidth="xl">
                    <Typography variant="subtitle2">
                        &#169;
                        {`${since ? since : ""}${since ? " - " : ""}${new Date().getFullYear()}`}
                    </Typography>
                </Container>
            </Box>
        </Box>
    );
};

export default LandingPage;
